// JOBE-0162.2: URL <-> state hook for the Organization directory.
// Owns the `?type=`, `?dept=`, and (JOBE-0162.3) `?ownerId=` query params.
// `all` (type/dept) and null (ownerId) are the defaults and are omitted
// from the URL so unfiltered views have clean URLs.
//
// Unknown type values are treated as `all` defensively — the URL might be
// from a future-rev page; no throw, no console.warn.

import { useSearchParams } from 'react-router-dom';

const KNOWN_TYPES = new Set(['all', 'human', 'agent']);

/**
 * @returns {{
 *   typeFilter: 'all'|'human'|'agent',
 *   deptFilter: string,
 *   ownerId: string|null,
 *   setTypeFilter: (next: string) => void,
 *   setDeptFilter: (next: string) => void,
 *   setOwnerId: (next: string|null) => void,
 * }}
 */
export function useOrganizationUrlState() {
  const [params, setParams] = useSearchParams();

  const rawType = params.get('type') || 'all';
  const typeFilter = KNOWN_TYPES.has(rawType) ? rawType : 'all';
  const deptFilter = params.get('dept') || 'all';
  const ownerId = params.get('ownerId') || null;

  const setTypeFilter = (next) => {
    const p = new URLSearchParams(params);
    if (!next || next === 'all') p.delete('type');
    else p.set('type', next);
    setParams(p, { replace: false });
  };

  const setDeptFilter = (next) => {
    const p = new URLSearchParams(params);
    if (!next || next === 'all') p.delete('dept');
    else p.set('dept', next);
    setParams(p, { replace: false });
  };

  const setOwnerId = (next) => {
    const p = new URLSearchParams(params);
    if (!next) p.delete('ownerId');
    else p.set('ownerId', next);
    setParams(p, { replace: false });
  };

  return { typeFilter, deptFilter, ownerId, setTypeFilter, setDeptFilter, setOwnerId };
}
